(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TagManager"] = factory();
	else
		root["TagManager"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.update = exports.dump = exports.track = exports.getNSO = exports.get = exports.set = exports.ready = exports.PROPERTY_ID = exports.NAMESPACE = exports.VERSION = undefined;
	
	var _package = __webpack_require__(65);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _tagManager = __webpack_require__(52);
	
	var _tagManager2 = _interopRequireDefault(_tagManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERSION = exports.VERSION = _package2.default.version;
	var NAMESPACE = exports.NAMESPACE = _tagManager2.default.NAMESPACE;
	var PROPERTY_ID = exports.PROPERTY_ID = _tagManager2.default.PROPERTY_ID;
	var ready = exports.ready = _tagManager2.default.ready;
	var set = exports.set = _tagManager2.default.set;
	var get = exports.get = _tagManager2.default.get;
	var getNSO = exports.getNSO = _tagManager2.default.getNSO;
	var track = exports.track = _tagManager2.default.track;
	var dump = exports.dump = _tagManager2.default.dump;
	var update = exports.update = _tagManager2.default.update;
	
	window.__VOONTO__.when('voonto:ready').then(function () {
	  var app = Voonto.getInstance();
	
	  app.on('vtm:track', function (event, data) {
	    data = typeof data === 'string' ? JSON.parse(data) : data;
	    set(data);
	    track();
	  });
	
	  app.on('vtm:set', function (event, data) {
	    data = typeof data === 'string' ? JSON.parse(data) : data;
	    set(data);
	  });
	
	  //  app.on('paywall:content', function() {
	  //    const provider = window.__VOONTO__.lookup('vocento.__PROVIDER__.paywall');
	  //
	  //    if (!!provider.isNewAnonymousSession) {
	  //      app.one('paywall:update', (config) => {
	  //        set(_getPaywallData(config));
	  //        track();
	  //      });
	  //    } else {
	  //      set(_getPaywallData(provider));
	  //      track();
	  //    }
	  //  });
	});
	
	/* Private */
	
	//function _getPaywallData(source) {
	//  return {
	//    IDEvolok:              source.pid,
	//    productoEvolok:        source.meter,
	//    nPaginasConsumidas:    source.count,
	//    nPaginasPermitidas:    source.max,
	//    autorizacionContenido: source.result,
	//    idCookieEvolok:        source.cookie
	//  };
	//}

/***/ },

/***/ 52:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _snippets = __webpack_require__(53);
	
	var _tracker2 = __webpack_require__(57);
	
	var _tracker3 = _interopRequireDefault(_tracker2);
	
	var _dataLayer = __webpack_require__(58);
	
	var _dataLayer2 = _interopRequireDefault(_dataLayer);
	
	var _constants = __webpack_require__(55);
	
	var _deploys = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(62).polyfill();
	
	var _tracked = false,
	    _tracker = false,
	    _legacy = false,
	    _isDirty = true,
	    _lib = null,
	    _data = null;
	
	var _trackerEnabled = _constants.currentScript.getAttribute('data-legacy-tracker') !== 'false',
	    _window = window,
	    RSVP = _window.RSVP,
	    parseUrl = _window.parseUrl,
	    STAGING = 'pre',
	    DEVELOPMENT = 'des',
	    AUTOTRACKING = 'autotracking',
	    AUTOTRACK_TIMEOUT = 1000,
	    ContentType = Object.freeze({
	  noticia: 1,
	  video: 2,
	  fotogaleria: 3,
	  audio: 5,
	  blog: 6
	}),
	    ready = RSVP.Promise.resolve(_constants.DATA_LOCATION).then(_createGlobal).then(_checkRequirements).then(_deployScripts).then(_checkPaywall).then(function () {
	  return TagManager.set((0, _dataLayer.defaults)());
	}).then(_autoTrackSecure).catch(function (reason) {
	  throw Error('[TagManager] ' + reason);
	});
	
	
	var TagManager = Object.preventExtensions({
	  NAMESPACE: _constants.DATA_LOCATION,
	  PROPERTY_ID: _deploys.propertyId,
	  ready: ready,
	
	  update: function update() {
	    return this.set((0, _dataLayer.defaults)());
	  },
	  set: function set() {
	    var data;
	
	    if (!arguments.length) {
	      throw Error('[TagManager] Empty arguments, expected 1 to n');
	    }
	
	    data = Object.assign.apply(Object, arguments);
	
	    var _loop = function _loop(i) {
	      if (!~_dataLayer2.default.indexOf(i)) {
	        throw Error('[TagManager] Property not recognized "' + i + '"');
	      }
	      if (typeof data[i] === 'string') {
	        data[i] = data[i].split(',').map(function (part) {
	          return _dataLayer.excludeSerialize.indexOf(i) > -1 ? part.trim() : (0, _dataLayer.serialize)(part.trim());
	        }).join(',');
	      }
	    };
	
	    for (var i in data) {
	      _loop(i);
	    }
	
	    Object.assign(_data, data);
	    _isDirty = true;
	
	    return this;
	  },
	  get: function get() {
	    return _data;
	  },
	  getNSO: function getNSO() {
	    var nso = window;
	
	    this.NAMESPACE.split('.').forEach(function (prop) {
	      return nso = nso[prop];
	    });
	
	    return nso;
	  },
	  track: function track() {
	    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'view';
	
	    if (!_isDirty) {
	      throw Error('[TagManager] Your are attempting to track same data twice');
	    }
	
	    _legacyLibs();
	    _statsTracker();
	
	    _lib.track(label);
	    _isDirty = false;
	    _tracked = true;
	
	    return true;
	  },
	  dump: function dump() {
	    console.log(this.getNSO());
	
	    return true;
	  }
	});
	
	exports.default = TagManager;
	
	/* Private */
	
	function _legacyLibs() {
	  if (_legacy) {
	    (0, _snippets.trackLegacy)();
	  } else {
	    (0, _snippets.snippets)();
	  }
	
	  _legacy = true;
	}
	
	function _statsTracker() {
	  var site, content, metaTit, trackerUrl, options, env, url, config;
	
	  if (!_trackerEnabled) {
	    return;
	  }
	
	  site = window.__VOONTO__.lookup('vocento.site');
	  content = window.__VOONTO__.lookup('vocento.site.content');
	  config = window.__VOONTO__.lookup('vocento.config.vtm');
	  metaTit = document.querySelector('meta[name="title"]');
	  env = '';
	  url = '//' + site.subdomain + '.' + site.tlddomain + parseUrl(window.location.href).pathname;
	
	  if (site.content && !site.content.newsId) {
	    return;
	  }
	  if (config.legacyTracker === false) {
	    return;
	  }
	  if (_tracker) {
	    return;
	  }
	
	  if (site.env === STAGING || site.env === DEVELOPMENT) {
	    env = site.env + '.';
	  }
	
	  trackerUrl = config.trackerUrl || 'http://' + env + 'metrics.' + site.tlddomain;
	
	  options = {
	    title: metaTit ? metaTit.content : '',
	    section: _data.seccion,
	    contentType: ContentType[_data.tipoContenido],
	    origin: _data.origenContenido,
	    clickType: '', // FUTURE: fill it
	    url: url,
	    id: content.newsId,
	    edition: _data.edicion,
	    tags: site.subdomain + '.' + site.tlddomain,
	    site: env ? 'metrics.' + site.tlddomain : undefined
	  };
	
	  window.__VOONTO__.when('voonto:ready').then(function () {
	    return new _tracker3.default(trackerUrl, options);
	  });
	  _tracker = true;
	}
	
	function _createGlobal(namespace) {
	  var nso = window;
	
	  namespace.split('.').forEach(function (prop) {
	    nso[prop] = nso[prop] || {};
	    nso = nso[prop];
	  });
	
	  return _data = nso;
	}
	
	function _deployScripts() {
	  return new RSVP.Promise(function (resolve, reject) {
	    _deploys.headScript.onload = function () {
	      _lib = window[_constants.GLOBAL_LIB_VAR];
	      if (document.body) {
	        resolve(document.body.appendChild(_deploys.bodyScript));
	      } else {
	        document.addEventListener('DOMContentLoaded', function () {
	          resolve(document.body.appendChild(_deploys.bodyScript));
	        });
	      }
	    };
	    _deploys.headScript.onerror = function () {
	      return reject('Provider script deployment error');
	    };
	    document.head.appendChild(_deploys.headScript);
	  });
	}
	
	function _checkRequirements() {
	  if (!_deploys.propertyId) {
	    throw Error('[TagManager] Developer, you must set "data-property-id" attribute within "<script>" element.');
	  }
	}
	
	function _autoTrackSecure() {
	  setTimeout(function () {
	    if (!_tracked) {
	      TagManager.set({
	        subseccion4: AUTOTRACKING
	      }).track();
	    }
	  }, AUTOTRACK_TIMEOUT);
	}
	
	function _checkPaywall() {
	  var config = window.__VOONTO__.lookup('vocento.config.paywall'),
	      provider = window.__VOONTO__.lookup('vocento.__PROVIDER__.paywall');
	
	  if (config.enabled && !!provider.isNewAnonymousSession) {
	    return window.__VOONTO__.when('paywall:ready').then(function (config) {
	      window.voc_pw_result = config.result;
	      window.voc_pw_pid = config.pid;
	      window.voc_pw_meter = config.meter;
	      window.voc_pw_count = config.count;
	      window.voc_pw_max = config.max;
	      window.voc_pw_cookie = config.cookie;
	      window.voc_pw_viewed = config.viewed;
	    });
	  }
	
	  window.voc_pw_result = provider.result;
	  window.voc_pw_pid = provider.pid;
	  window.voc_pw_meter = provider.meter;
	  window.voc_pw_count = provider.count;
	  window.voc_pw_max = provider.max;
	  window.voc_pw_cookie = provider.cookie;
	  window.voc_pw_viewed = provider.viewed;
	
	  return RSVP.resolve();
	}

/***/ },

/***/ 53:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.snippets = snippets;
	exports.trackLegacy = trackLegacy;
	
	var _vocVars = __webpack_require__(54);
	
	var _constants = __webpack_require__(55);
	
	var _digitalContext = __webpack_require__(56);
	
	var _digitalContext2 = _interopRequireDefault(_digitalContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _gtm = _constants.currentScript.getAttribute('data-legacy-gtm'),
	    _googleAnalytics = _constants.currentScript.getAttribute('data-legacy-google-analytics'),
	    _krux = _constants.currentScript.getAttribute('data-legacy-krux'),
	    _chartbeat = _constants.currentScript.getAttribute('data-legacy-chartbeat'),
	    _inspectlet = _constants.currentScript.getAttribute('data-legacy-inspectlet'),
	    _crazyegg = _constants.currentScript.getAttribute('data-legacy-crazyegg'),
	    _comscore = _constants.currentScript.getAttribute('data-legacy-comscore'),
	    _facebook = _constants.currentScript.getAttribute('data-legacy-facebook');
	
	function snippets() {
	  var promise;
	
	  window.voc_krux = _krux; // FIXME: this is not the right place
	
	  if (_krux || _chartbeat || _comscore) {
	    promise = (0, _vocVars.initP)();
	  }
	  if (_krux) {
	    promise.then(function () {
	      window.context = _digitalContext2.default.getContext();
	      _kruxSnippet();
	    });
	  }
	  if (_comscore) {
	    promise.then(function () {
	      return _comscoreSnippet();
	    });
	  }
	  if (_chartbeat) {
	    promise.then(function () {
	      return _chartbeatSnippet();
	    });
	  }
	  if (_gtm) {
	    _gtmSnippet();
	  }
	  if (_googleAnalytics) {
	    _googleanalyticsSnippet.init(_googleAnalytics).track();
	  }
	  if (_inspectlet) {
	    _inspectletSnippet();
	  }
	  if (_crazyegg) {
	    _crazyeggSnippet();
	  }
	  if (_facebook) {
	    _facebookSnippet.init(1234567890).track();
	  }
	}
	
	function trackLegacy() {
	  // NOTE: call initP is not necessary by now
	  if (_googleAnalytics) {
	    _googleanalyticsSnippet.getInstance().track();
	  }
	  if (_facebook) {
	    _facebookSnippet.getInstance().track();
	  }
	  if (_comscore) {
	    _comscoreSnippet();
	  }
	}
	
	/* Private */
	var _googleanalyticsSnippet = function () {
	  var instance = void 0;
	  var _init = function _init(trackerId) {
	
	    (function (i, s, o, g, r, a, m) {
	      i.GoogleAnalyticsObject = r;i[r] = i[r] || function () {
	        (i[r].q = i[r].q || []).push(arguments);
	      }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
	    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	
	    window.ga('create', trackerId, 'auto');
	
	    return {
	      track: function track() {
	        window.ga('send', 'pageview');
	      }
	    };
	  };
	
	  return {
	    init: function init(trackerId) {
	      if (!instance) {
	        instance = _init(trackerId);
	      }
	      return instance;
	    },
	    getInstance: function getInstance() {
	      if (!instance) {
	        throw Error('Google analytics wasn\'t initialized');
	      }
	      return instance;
	    },
	    flushInstance: function flushInstance() {
	      instance = undefined;
	    }
	  };
	}();
	
	var _facebookSnippet = function () {
	  var instance = void 0;
	  var _init2 = function _init2(trackerId) {
	    !function (f, b, e, v, n, t, s) {
	      if (f.fbq) return;n = f.fbq = function () {
	        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
	      };if (!f._fbq) f._fbq = n;n.push = n;n.loaded = !0;n.version = '2.0';n.queue = [];t = b.createElement(e);t.async = !0;t.src = v;s = b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t, s);
	    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
	    window.fevents = true;
	    window.fbq('init', trackerId);
	
	    return {
	      track: function track() {
	        window.fbq('track', 'PageView');
	      }
	    };
	  };
	
	  return {
	    init: function init(trackerId) {
	      if (!instance) {
	        instance = _init2(trackerId);
	      }
	      return instance;
	    },
	    getInstance: function getInstance() {
	      if (!instance) {
	        throw Error('facebook tracking wasn\'t initialized');
	      }
	      return instance;
	    },
	    flushInstance: function flushInstance() {
	      instance = undefined;
	    }
	  };
	}();
	
	function _comscoreSnippet() {
	  function udm_(e) {
	    /* jshint ignore:line */
	    if (typeof window.c7 === 'undefined' || window.c7 === '') {
	      var t = 'comScore=',
	          n = document,
	          r = n.cookie,
	          i = '',
	          s = 'indexOf',
	          o = 'substring',
	          u = 'length',
	          a = 2048,
	          f,
	          l = '&ns_',
	          c = '&',
	          h,
	          p,
	          d,
	          v,
	          m = window,
	          g = m.encodeURIComponent || escape;if (r[s](t) + 1) for (d = 0, p = r.split(';'), v = p[u]; d < v; d++) {
	        h = p[d][s](t), h + 1 && (i = c + window.unescape(p[d][o](h + t[u])));
	      }e += l + '_t=' + +new Date() + l + 'c=' + (n.characterSet || n.defaultCharset || '') + '&c8=' + g(n.title) + i + '&c7=' + g(n.URL) + '&c9=' + g(n.referrer), e[u] > a && e[s](c) > 0 && (f = e[o](0, a - 8).lastIndexOf(c), e = (e[o](0, f) + l + 'cut=' + g(e[o](f + 1)))[o](0, a)), n.images ? (h = new Image(), m.ns_p || (window.ns_p = h), h.src = e) : n.write('<', 'p', '><', 'img src="', e, '" height="1" width="1" alt="*"', '><', '/p', '>');
	    } else {
	      var t = 'comScore=',
	          n = document,
	          r = n.cookie,
	          i = '',
	          s = 'indexOf',
	          o = 'substring',
	          u = 'length',
	          a = 2048,
	          f,
	          l = '&ns_',
	          c = '&',
	          h,
	          p,
	          d,
	          v,
	          m = window,
	          g = m.encodeURIComponent || escape;if (r[s](t) + 1) for (d = 0, p = r.split(';'), v = p[u]; d < v; d++) {
	        h = p[d][s](t), h + 1 && (i = c + window.unescape(p[d][o](h + t[u])));
	      }e += l + '_t=' + +new Date() + l + 'c=' + (n.characterSet || n.defaultCharset || '') + '&c8=' + g(n.title) + i + '&c9=' + g(n.referrer), e[u] > a && e[s](c) > 0 && (f = e[o](0, a - 8).lastIndexOf(c), e = (e[o](0, f) + l + 'cut=' + g(e[o](f + 1)))[o](0, a)), n.images ? (h = new Image(), m.ns_p || (window.ns_p = h), h.src = e) : n.write('<', 'p', '><', 'img src="', e, '" height="1" width="1" alt="*"', '><', '/p', '>');
	    }
	  }
	
	  if (!window.c7) {
	    udm_('http' + (document.location.href.charAt(4) == 's' ? 's://sb' : '://b') + '.scorecardresearch.com/b?c1=2&c2=' + _comscore + '&ns_site=' + ns_site + '&name=' + window.voc_name + '&voc_site=' + window.voc_site + '&voc_se=' + window.voc_se + '&voc_s1=' + window.voc_s1 + '&voc_s2=' + window.voc_s2 + '&voc_s3=' + window.voc_s3 + '&voc_s4=' + window.voc_s4 + '&voc_tn=' + window.voc_tn + '&voc_ho=' + window.voc_ho + '&voc_tc=' + window.voc_tc + '&voc_ed=' + window.voc_ed + '&voc_au=' + window.voc_au + '&voc_fep=' + window.voc_fep + '&voc_fem=' + window.voc_fem + '&voc_or=' + window.voc_or + '&voc_pr=' + window.voc_pr + '&voc_pl=' + window.voc_pl + '&voc_pu=' + window.voc_pu + '&voc_usrid=' + window.voc_usrid + '&voc_tusr=' + window.voc_tusr + '&voc_ate=' + window.voc_ate + '&voc_idi=' + window.voc_idi + '&voc_usrag=' + window.voc_usrag + '&voc_usrcp=' + window.voc_usrcp + '&voc_usrgen=' + window.voc_usrgen + '&voc_pw_pid=' + window.voc_pw_pid + '&voc_pw_meter=' + window.voc_pw_meter + '&voc_pw_count=' + window.voc_pw_count + '&voc_pw_max=' + window.voc_pw_max + '&voc_pw_result=' + window.voc_pw_result + '&voc_pw_cookie=' + window.voc_pw_cookie + '&ns_http_status=' + ns_http_status + '&voc_adp=' + window.voc_adp + '&voc_usrser=' + window.voc_usrser + '&voc_usrsvs=' + window.voc_usrsvs + '&voc_adb=' + window.voc_adb + '&voc_krux=' + window.voc_krux);
	  } else {
	    udm_('http' + (document.location.href.charAt(4) == 's' ? 's://sb' : '://b') + '.scorecardresearch.com/b?c1=2&c2=' + _comscore + '&ns_site=' + ns_site + '&name=' + window.voc_name + '&voc_site=' + window.voc_site + '&voc_se=' + window.voc_se + '&voc_s1=' + window.voc_s1 + '&voc_s2=' + window.voc_s2 + '&voc_s3=' + window.voc_s3 + '&voc_s4=' + window.voc_s4 + '&voc_tn=' + window.voc_tn + '&voc_ho=' + window.voc_ho + '&voc_tc=' + window.voc_tc + '&voc_ed=' + window.voc_ed + '&voc_au=' + window.voc_au + '&voc_fep=' + window.voc_fep + '&voc_fem=' + window.voc_fem + '&voc_or=' + window.voc_or + '&voc_pr=' + window.voc_pr + '&voc_pl=' + window.voc_pl + '&voc_pu=' + window.voc_pu + '&voc_usrid=' + window.voc_usrid + '&voc_tusr=' + window.voc_tusr + '&voc_ate=' + window.voc_ate + '&voc_idi=' + window.voc_idi + '&voc_usrag=' + window.voc_usrag + '&voc_usrcp=' + window.voc_usrcp + '&voc_usrgen=' + window.voc_usrgen + '&voc_pw_pid=' + window.voc_pw_pid + '&voc_pw_meter=' + window.voc_pw_meter + '&voc_pw_count=' + window.voc_pw_count + '&voc_pw_max=' + window.voc_pw_max + '&voc_pw_result=' + window.voc_pw_result + '&voc_pw_cookie=' + window.voc_pw_cookie + '&ns_http_status=' + ns_http_status + '&c7=' + window.c7 + '&voc_adp=' + window.voc_adp + '&voc_usrser=' + window.voc_usrser + '&voc_usrsvs=' + window.voc_usrsvs + '&voc_adb=' + window.voc_adb + '&voc_krux=' + window.voc_krux);
	  }
	}
	
	function _gtmSnippet() {
	  // NOTE: dataLayer?
	  (function (w, d, s, l, i) {
	    w[l] = w[l] || [];
	    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
	    var f = d.getElementsByTagName(s)[0],
	        j = d.createElement(s),
	        dl = l != 'dataLayer' ? '&l=' + l : '';
	    j.async = true;
	    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
	    f.parentNode.insertBefore(j, f);
	  })(window, document, 'script', 'dataLayer', _gtm);
	}
	
	function _kruxSnippet() {
	  _constants.currentScript.className = 'kxct';
	  _constants.currentScript.setAttribute('data-id', _krux);
	  _constants.currentScript.setAttribute('data-timing', 'async');
	  _constants.currentScript.setAttribute('data-version', '3.0');
	
	  window.Krux || ((window.Krux = function () {
	    window.Krux.q.push(arguments);
	  }).q = []);
	  (function () {
	    var k = document.createElement('script');k.type = 'text/javascript';k.async = true;
	    k.src = (document.location.protocol === 'https:' ? 'https:' : 'http:') + '//cdn.krxd.net/controltag/' + _krux + '.js';
	    var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(k, s);
	  })();
	
	  //  window.Krux || ((window.Krux = function() {window.Krux.q.push(arguments);}).q = []);
	  //
	  //  (function IIFE(){
	  //    var k = document.createElement('script');
	  //    k.type = 'text/javascript';
	  //    k.async = true;
	  //    var m, src = (m = document.location.href.match(/\bkxsrc=([^&]+)/)) && decodeURIComponent(m[1]); /* jshint ignore:line */
	  //    k.src = /^https?:\/\/([^\/]+\.)?krxd\.net(:\d{1,5})?\//i.test(src) ? src : src === 'disable' ? '' : (location.protocol === 'https:' ? 'https:' : 'http:') + '//cdn.krxd.net/controltag?confid=' + _krux;
	  //    var s = document.getElementsByTagName('script')[0];
	  //    s.parentNode.insertBefore(k, s);
	  //  }());
	
	  // TODO: preguntar por el snippet de conexión con DFP
	}
	
	function _chartbeatSnippet() {
	  window._sf_async_config = {};
	  window._sf_async_config.uid = _chartbeat;
	  window._sf_async_config.domain = window.vocento.site.tlddomain; // FIXME
	  window._sf_async_config.sections = '' + (window.voc_s4 !== '' ? window.voc_s4 + ',' : '') + (window.voc_s3 !== '' ? window.voc_s3 + ',' : '') + (window.voc_s2 !== '' ? window.voc_s2 + ',' : '') + (window.voc_s1 !== '' ? window.voc_s1 + ',' : '') + window.voc_se;
	  window._sf_async_config.authors = '' + window.voc_au;
	
	  (function IIFE() {
	    function loadChartbeat() {
	      window._sf_endpt = new Date().getTime();
	      var e = document.createElement('script');
	      e.setAttribute('language', 'javascript');
	      e.setAttribute('type', 'text/javascript');
	      e.setAttribute('src', ('https:' == document.location.protocol ? 'https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/' : 'http://static.chartbeat.com/') + 'js/chartbeat.js');
	      document.body.appendChild(e);
	    }
	    var oldonload = window.onload;
	    window.onload = typeof window.onload != 'function' ? loadChartbeat : function () {
	      oldonload();
	      loadChartbeat();
	    };
	  })();
	}
	
	function _inspectletSnippet() {
	  window.__insp = window.__insp || [];
	  window.__insp.push(['wid', _inspectlet]);
	
	  (function IIFE() {
	    function ldinsp() {
	      if (typeof window.__inspld != 'undefined') {
	        return;
	      }
	      window.__inspld = 1;
	      var insp = document.createElement('script');
	      insp.type = 'text/javascript';
	      insp.async = true;
	      insp.id = 'inspsync';
	      insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js';
	      var x = document.getElementsByTagName('script')[0];
	      x.parentNode.insertBefore(insp, x);
	    }
	    setTimeout(ldinsp, 500);
	    document.readyState != 'complete' ? window.attachEvent ? window.attachEvent('onload', ldinsp) : window.addEventListener('load', ldinsp, false) : ldinsp();
	  })();
	}
	
	function _crazyeggSnippet() {
	  setTimeout(function () {
	    var a = document.createElement('script');
	    var b = document.getElementsByTagName('script')[0];
	    a.src = document.location.protocol + '//script.crazyegg.com/pages/scripts/' + _crazyegg + '.js?' + Math.floor(new Date().getTime() / 3600000);
	    a.async = true;a.type = 'text/javascript';
	    b.parentNode.insertBefore(a, b);
	  }, 1);
	}

/***/ },

/***/ 54:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initP = initP;
	var _window = window,
	    Cookies = _window.Cookies;
	function initP() {
	  var COVER = 'portada',
	      TEST_PREFIX = 'test',
	      DOT = '.',
	      ZERO = 0,
	      Env = Object.freeze({
	    DEVELOPMENT: 'des',
	    STAGING: 'pre'
	  }),
	      _site = window.__VOONTO__.lookup('vocento.site'),
	      _data = window.__VOONTO__.lookup('vocento.dtm.data'),
	      _vocUid = decodeURIComponent(Cookies.get('voc_uid')),
	      _evolok = Cookies.get('ev_sid'),
	      _window2 = window,
	      AdblockDetector = _window2.AdblockDetector,
	      RSVP = _window2.RSVP;
	
	
	  var _cookie = _vocUid === 'undefined' ? {} : JSON.parse(_vocUid);
	
	  window.voc_site = window.voc_site || _site.media;
	
	  if (_site.env === Env.DEVELOPMENT || _site.env === Env.STAGING) {
	    window.voc_site = TEST_PREFIX + '-' + window.voc_site;
	  }
	
	  window.ns_site = window.voc_site;
	  window.voc_se = _data.seccion;
	  window.voc_s1 = _data.subseccion1;
	  window.voc_s2 = _data.subseccion2;
	  window.voc_s3 = _data.subseccion3;
	  window.voc_s4 = _data.subseccion4;
	  window.voc_tn = _data.titular;
	  window.voc_tc = _data.tipoContenido;
	  window.voc_ed = _data.edicion;
	  window.voc_au = _data.firmaAutor;
	  window.voc_or = _data.origenContenido;
	  window.voc_pr = _data.tipoDominio;
	  window.voc_fep = _data.fechaPrimeraPublicacion;
	  window.voc_fem = _data.fechaModificacion;
	  window.voc_pl = _data.plataformaContenido;
	  window.voc_pu = _data.sistemaPublicacion;
	  window.voc_usrid = _cookie.uid || '';
	  window.voc_tusr = window.__VOONTO__.getUserType();
	  window.voc_usrcp = _cookie.zip || '';
	  window.voc_usrgen = _cookie.gender || '';
	  window.voc_usrag = _cookie.age || '';
	  window.voc_ate = ''; // FIXME
	  window.voc_idi = _data.idioma;
	  window.voc_ho = _data.origenPortada;
	  window.voc_name = _concat([window.voc_se, window.voc_s1, window.voc_s2, window.voc_s3, window.voc_s4, window.voc_tn], DOT);
	  window.ns_http_status = ''; // FIXME
	  window.voc_adp = ZERO;
	  window.voc_usrser = _cookie.dataRegistrationService || '';
	  window.voc_usrsvs = _cookie.dataServicesSsoGroup || '';
	  window.voc_adb = ZERO;
	  window.voc_krux = window.voc_krux || ZERO;
	  window.voc_pw_pid = _data.IDEvolok;
	  window.voc_pw_meter = _data.productoEvolok;
	  window.voc_pw_count = _data.nPaginasConsumidas;
	  window.voc_pw_max = _data.nPaginasPermitidas;
	  window.voc_pw_result = _data.autorizacionContenido;
	  window.voc_pw_cookie = _data.idCookieEvolok || _evolok;
	
	  // FIXME: ask
	  if (window.voc_pw_cookieMM) {
	    window.voc_pw_cookie = window.voc_pw_cookieMM;
	  }
	
	  // NOTE: adbd enabled
	  if ('AdblockDetector' in window) {
	    var adbdCookie = void 0,
	        url = void 0,
	        re = void 0,
	        results = void 0,
	        nsMChannel = void 0,
	        adbOrigin = void 0;
	
	    return window.__VOONTO__.when('adbd:ready').then(function (hasAdblocker) {
	      if (hasAdblocker) {
	        adbdCookie = Cookies.get(AdblockDetector.Cookie.NAME);
	        url = window.location.href.toLowerCase();
	        re = new RegExp("[?&]ns_mchannel(=([^&#]*)|&|#|$)");
	        results = re.exec(url);
	
	        // FIXME: only ppll?
	        if (!adbdCookie && window.voc_se === COVER) {
	          window.voc_adb = '1-popup';
	        } else {
	          window.voc_adb = '1-capa-' + window.voc_tc;
	        }
	
	        if (results && results[2]) {
	          nsMChannel = decodeURIComponent(results[2].replace(/\+/g, ' '));
	
	          if (nsMChannel.length > 0) {
	            adbOrigin = nsMChannel;
	            nsMChannel = nsMChannel.split('-');
	            if (nsMChannel[1] && (nsMChannel[1] == 'capa' || nsMChannel[1] == 'popup')) {
	              window.voc_adb = adbOrigin;
	            }
	          }
	        }
	      }
	    });
	  } else {
	    return RSVP.resolve();
	  }
	}
	
	/* Private */
	
	function _concat(items, char) {
	  return items.filter(function (item) {
	    return !!item;
	  }).join(char);
	}

/***/ },

/***/ 55:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DATA_LOCATION = exports.DATA_LOCATION = 'vocento.dtm.data';
	var VOCENTO_ID = exports.VOCENTO_ID = 'ed924dd314b24fbc7af1a00ec99aee0d3b3ef5b9';
	var TAG_MANAGER_URL = exports.TAG_MANAGER_URL = '//assets.adobedtm.com/' + VOCENTO_ID + '/satelliteLib-{{property-id}}.js';
	var GLOBAL_LIB_VAR = exports.GLOBAL_LIB_VAR = '_satellite';
	
	var HEAD_DEPLOY_SELECTOR_ID = exports.HEAD_DEPLOY_SELECTOR_ID = 'vtm-head-deploy';
	var BODY_DEPLOY_SELECTOR_ID = exports.BODY_DEPLOY_SELECTOR_ID = 'vtm-body-deploy';
	
	var currentScript = exports.currentScript = document.currentScript || function () {
	  var scripts = document.getElementsByTagName('script');
	  return scripts[scripts.length - 1];
	}();

/***/ },

/***/ 56:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var booted = false;
	var context = {
	  analytics: {},
	  browser: {},
	  content: {},
	  ecommerce: {},
	  user: {}
	};
	
	var getContentFromMetaTag = function getContentFromMetaTag(name) {
	  var meta = document.querySelector('meta[name="' + name + '"]');
	  return meta ? meta.getAttribute('content') : '';
	};
	
	var fillAnalytics = function fillAnalytics() {
	  context.analytics = {
	    comscore: {
	      advertisement_blocker: window.voc_adb,
	      content: {
	        author: window.voc_au,
	        language: window.voc_idi,
	        modification_date: window.voc_fem,
	        publication_date: window.voc_fep,
	        title: window.voc_tn,
	        type: window.voc_tc
	      },
	      cover_source: window.voc_ho,
	      domain_type: window.voc_pr,
	      edition: window.voc_ed,
	      information_source: window.voc_or,
	      krux: {
	        tagged: window.voc_krux
	      },
	      mobile_cookie: window.voc_adp,
	      platform_content: window.voc_pl,
	      paywall: {
	        authorization: window.voc_pw_result,
	        cookie: window.voc_pw_cookie,
	        count: window.voc_pw_count,
	        counter_max: window.voc_pw_max,
	        meter: window.voc_pw_meter,
	        uid: window.voc_pw_pid
	      },
	      publish_system: window.voc_pu,
	      section: {
	        level_1: window.voc_s1,
	        level_2: window.voc_s2,
	        level_3: window.voc_s3,
	        level_4: window.voc_s4,
	        name: window.voc_se
	      },
	      site: {
	        id: window.ns_site,
	        name: window.voc_site
	      },
	      topic_grouping: window.voc_ate,
	      topics: window.voc_top,
	      user: {
	        access: window.voc_usrser,
	        age: window.voc_usrag,
	        id: window.voc_usrid,
	        gender: window.voc_usrgen,
	        navigation_track: window.voc_usrsvs,
	        postal_code: window.voc_usrcp,
	        type: window.voc_tusr
	      }
	    }
	  };
	};
	
	/**
	 * Fills the context with the browser data
	 */
	var fillBrowser = function fillBrowser() {
	  context.browser = {
	    domain: document.domain,
	    url: document.URL
	  };
	};
	
	var fillContent = function fillContent() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _data = {
	    section: '',
	    site: '',
	    subsection: '',
	    type: '',
	    metadata: {
	      author: '',
	      description: '',
	      keywords: '',
	      title: ''
	    }
	  };
	
	  if (data.site) {
	    _data.site = data.site;
	  }
	
	  if (data.section) {
	    _data.section = data.section;
	  }
	
	  if (data.subsection) {
	    _data.subsection = data.subsection;
	  }
	
	  if (data.type) {
	    _data.type = data.type;
	  }
	
	  var hasMetadata = _typeof(data.metadata) === 'object' ? true : false;
	
	  if (hasMetadata && data.metadata.author) {
	    _data.metadata.author = '' + data.metadata.author;
	  } else {
	    _data.metadata.author = getContentFromMetaTag('author');
	  }
	
	  if (hasMetadata && data.metadata.description) {
	    _data.metadata.description = '' + data.metadata.description;
	  } else {
	    _data.metadata.description = getContentFromMetaTag('description');
	  }
	
	  if (hasMetadata && data.metadata.keywords) {
	    _data.metadata.keywords = '' + data.metadata.keywords;
	  } else {
	    _data.metadata.keywords = getContentFromMetaTag('news_keywords');
	    if (_data.metadata.keywords === '') {
	      _data.metadata.keywords = getContentFromMetaTag('keywords');
	    }
	  }
	
	  if (hasMetadata && data.metadata.title) {
	    _data.metadata.title = '' + data.metadata.title;
	  } else {
	    _data.metadata.title = document.title;
	  }
	
	  context.content = _data;
	};
	
	var fillECommerce = function fillECommerce() {
	  context.ecommerce = {
	    client: {
	      id: window.ns_client_id
	    },
	    order: {
	      id: window.ns_order_id,
	      product: {
	        id: window.ns_pro_id,
	        name: window.ns_brand,
	        category: window.ns_prod_grp,
	        price: window.ns_prod_price
	      },
	      quantity: window.ns_qty
	    },
	    shop: {
	      name: window.ns_shop
	    }
	  };
	};
	
	var fillUser = function fillUser() {
	  context.user = {};
	};
	
	var init = function init() {
	  var data = {
	    site: window.voc_site,
	    section: window.voc_se,
	    subsection: window.voc_s1,
	    type: window.voc_tc
	  };
	
	  fillAnalytics();
	  fillBrowser();
	  fillContent(data);
	  fillECommerce();
	  fillUser();
	
	  booted = true;
	};
	
	exports.default = {
	  isBooted: function isBooted() {
	    return booted;
	  },
	  getContext: function getContext() {
	    if (false === booted) {
	      init();
	    }
	
	    return context;
	  },
	  init: init
	};

/***/ },

/***/ 57:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _window = window,
	    Cookies = _window.Cookies;
	
	
	var Tracker = function Tracker(_trackerUrl, _ref) {
	  var title = _ref.title,
	      section = _ref.section,
	      contentType = _ref.contentType,
	      origin = _ref.origin,
	      clickType = _ref.clickType,
	      url = _ref.url,
	      id = _ref.id,
	      edition = _ref.edition,
	      tags = _ref.tags,
	      site = _ref.site;
	
	
	  /**
	   * Versión dej js
	   */
	  var _version = '1.0';
	
	  /**
	   * Log
	   */
	  //  var log = console.log;
	
	  /**
	   * URL del servicio de tracking
	   */
	  var trackerUrl = null;
	
	  /**
	   * Establecer las variables desde la configuración
	   */
	  function setVarsFromConfig() {
	    trackerUrl = _trackerUrl;
	    //    log('Tracker::setVarsFromConfig => trackerUrl: ' + trackerUrl);
	
	    return this;
	  }
	
	  /**
	   * Establece valor de trackerUrl según el valor pasado como parametro
	   * @param (string) url
	   */
	  function setTrackerUrl(url) {
	    trackerUrl = url;
	
	    return this;
	  }
	
	  /**
	   * Devuelve trackerUrl del medio
	   */
	  function getTrackerUrl() {
	    return trackerUrl;
	  }
	
	  /**
	   * Enviar visita a plataforma de estadística
	   * @param (string) title
	   * @param (string) section
	   * @param (string) contentType
	   * @param (string) origin
	   * @param (string) clickType
	   * @param (string) url
	   * @param (string) id
	   * @param (string) edition (no requerido)
	   * @param (string) tags (no requerido)
	   */
	  function sendViewStats(title, section, contentType, origin, clickType, url, id, edition, tags, evo_sid, site) {
	    if (typeof title !== 'undefined' && title !== null && typeof section !== 'undefined' && section !== null && typeof contentType !== 'undefined' && contentType !== null && typeof origin !== 'undefined' && origin !== null && typeof clickType !== 'undefined' && clickType !== null && typeof url !== 'undefined' && url !== null && typeof id !== 'undefined' && id !== null && typeof evo_sid !== 'undefined' && evo_sid !== null) {
	      var voc_adb = 0;
	      var voc_cookies = 0;
	      if (vocAdblock) {
	        voc_adb = 1;
	      }
	      if (cookiesEnabled) {
	        voc_cookies = 1;
	      }
	      var urlTracking = trackerUrl + '/stats/v2/visit?title=' + window.escape(title) + '&section=' + section + '&content_type=' + contentType + '&origin=' + origin + '&click_type=' + clickType + '&url=' + window.escape(url) + '&id=' + id + '&edition=' + edition + '&tags=' + window.escape(tags);
	      urlTracking += '&id_user=' + evo_sid + '&adb_enabled=' + voc_adb + '&cookies_enabled=' + voc_cookies;
	      //      log('Tracker::sendViewStats => ' + urlTracking);
	
	      if (site) {
	        urlTracking += '&site=' + site;
	      }
	
	      window.$.ajax({
	        url: urlTracking,
	        dataType: 'jsonp',
	        async: true
	      });
	    } else {
	      throw Error('[TagManager] tracker config');
	    }
	  }
	
	  /**
	   * Nos dice si las cookies estan habilitadas
	   */
	  function areCookiesEnabled() {
	    var cookieEnabled = window.navigator.cookieEnabled ? true : false;
	    if (typeof window.navigator.cookieEnabled == "undefined" && !cookieEnabled) {
	      document.cookie = "testcookie";
	      cookieEnabled = document.cookie.indexOf("testcookie") != -1 ? true : false;
	    }
	    return cookieEnabled;
	  }
	
	  /**
	   * Crea una cadena aleatoria que sirve como id de usuario en caso de no existir uno.
	   */
	  function makeid() {
	    var text = "";
	    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	    for (var i = 0; i < 25; i++) {
	      text += possible.charAt(Math.floor(Math.random() * possible.length));
	    }
	    return text;
	  }
	
	  /**
	   * Obtiene el identificador de usuario.
	   * Si existe cookie ev_sid coge ese, sino busca si existe voc_uid (solo usuarios registrados).
	   * Si el usuario es registrado mete el uid en stats_uid para saber cuando no esta registrado que usuario es.
	   * Si no esta con sesión iniciada y no existe ev_sid se genera una cadena aleatoria que se guarda en la cookie stats_uid.
	   */
	  function getUserId() {
	    var user_id = Cookies.get("ev_sid");
	    if (user_id === undefined) {
	      var uid_obj = Cookies.get("voc_uid");
	      if (uid_obj) {
	        user_id = uid_obj.uid;
	        Cookies.set('stats_uid', user_id, {
	          path: '/'
	        });
	      }
	    }
	    if (user_id === undefined) {
	      user_id = Cookies.get('stats_uid');
	      if (user_id === undefined) {
	        user_id = makeid();
	        Cookies.set('stats_uid', user_id, {
	          path: '/'
	        });
	      }
	    }
	    return user_id;
	  }
	
	  /**
	   * Ejecutable al instanciar el objeto
	   */
	  setVarsFromConfig();
	
	  /**
	   * Recogemos los parámetros (de la variable global _voctrack)
	   */
	  // var params = Array();
	  // for(var cont = 0; cont < parent._voctrack.length; cont++) {
	  //     params[parent._voctrack[cont][0]] = parent._voctrack[cont][1];
	  // }
	
	  /**
	   * Recogemos si el adblock esta activado o no
	   */
	  var vocAdblock = false;
	  if (window.voc_adb) {
	    vocAdblock = true;
	  }
	
	  /**
	   * Recogemos si las cookies estan activadas o no
	   */
	  var cookiesEnabled = false;
	  cookiesEnabled = areCookiesEnabled();
	
	  /**
	   * Recogemos el user_id actual
	   */
	  var user_id = getUserId();
	
	  /**
	   * Tracking de la visita
	   */
	  sendViewStats(title, section, contentType, origin, clickType, url, id, edition, tags, user_id, site);
	
	  /**
	   * Métodos públicos
	   */
	  return {
	    version: function version() {
	      return _version;
	    },
	    setTrackerUrl: setTrackerUrl,
	    getTrackerUrl: getTrackerUrl,
	    sendViewStats: sendViewStats
	  };
	};
	
	exports.default = Tracker;

/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.excludeSerialize = exports.properties = undefined;
	exports.serialize = serialize;
	exports.defaults = defaults;
	
	var _case = __webpack_require__(59);
	
	var _case2 = _interopRequireDefault(_case);
	
	var _constants = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NO = 'no',
	    EMPTY = '',
	    OTHERS = 'otros',
	    ANONYMOUS = 'anonimo',
	    ZERO = 0,
	    ONE = 1,
	    TWO = 2,
	    AUT = 'aut',
	    ES = 'es',
	    WEB_CONTENT = 'contenido-web',
	    M_RESPONSIVE = 'm-responsive',
	    METHODE = 'methode',
	    _params = {},
	    _query = {},
	    _userType = window.__VOONTO__.getUserType(),
	    _krux = _constants.currentScript.getAttribute('data-legacy-krux'),
	    _site = window.__VOONTO__.lookup('vocento.site'),
	    _editions = window.__VOONTO__.lookup('vocento.site.editions'),
	    _window = window,
	    Cookies = _window.Cookies,
	    parseUrl = _window.parseUrl,
	    is = _window.is,
	    _vocUid = decodeURIComponent(Cookies.get('voc_uid'));
	
	
	var _urlParts = window.location.pathname.substring(1).split('/');
	
	if (_hasSubdomain()) {
	  _urlParts = [_site.subdomain || ''].concat(_urlParts);
	}
	
	window.location.hash.substring(1).split('&').forEach(function (pair) {
	  _params[pair.split('=').shift()] = pair.split('=').pop();
	});
	
	window.location.search.substring(1).split('&').forEach(function (pair) {
	  _query[pair.split('=').shift()] = pair.split('=').pop();
	});
	
	window.customService = window.customService || window.__VOONTO__.lookup('vocento.site').media;
	
	function serialize(str) {
	  return _case2.default.kebab(str);
	}
	
	function defaults() {
	  if (!window.voc_se) {
	    window.voc_tc = OTHERS;
	  }
	  window.voc_top && (window.voc_top = window.voc_top.replace(/;/g, ','));
	
	  window.voc_usrid = _vocUid === 'undefined' ? undefined : JSON.parse(_vocUid).uid;
	
	  return {
	    scrollInfinito: _query.vtm_scrollInfinito || _params.vtm_scrollInfinito || false,
	    seccion: _query.vtm_seccion || _params.vtm_seccion || window.voc_se || _getValueAtIndex(_urlParts, 0) || EMPTY,
	    subseccion1: _query.vtm_subseccion1 || _params.vtm_subseccion1 || window.voc_s1 || (!window.voc_se ? _getValueAtIndex(_urlParts, 1) : EMPTY) || EMPTY,
	    subseccion2: _query.vtm_subseccion2 || _params.vtm_subseccion2 || window.voc_s2 || (!window.voc_se ? _getValueAtIndex(_urlParts, 2) : EMPTY) || EMPTY,
	    subseccion3: _query.vtm_subseccion3 || _params.vtm_subseccion3 || window.voc_s3 || (!window.voc_se ? _getValueAtIndex(_urlParts, 3) : EMPTY) || EMPTY,
	    subseccion4: _query.vtm_subseccion4 || _params.vtm_subseccion4 || (!window.voc_s3 ? EMPTY : window.voc_s4 || (!window.voc_se ? _getValueAtIndex(_urlParts, 4) : EMPTY)) || EMPTY,
	    titular: _query.vtm_titular || _params.vtm_titular || window.voc_tn || document.title,
	    errorPagina: _query.vtm_errorPagina || _params.vtm_errorPagina || EMPTY,
	    tipoDominio: _query.vtm_tipoDominio || _params.vtm_tipoDominio || window.voc_pr || EMPTY,
	    edicion: _query.vtm_edicion || _params.vtm_edicion || window.voc_ed || _editions.current || EMPTY,
	    tipoContenido: _query.vtm_tipoContenido || _params.vtm_tipoContenido || window.voc_tc || EMPTY,
	    tipoContenidoA: _query.vtm_tipoContenidoA || _params.vtm_tipoContenidoA || window.voc_tcnew || EMPTY,
	    contenidoPremium: _query.vtm_contenidoPremium || _params.vtm_contenidoPremium || NO,
	    plataformaContenido: _query.vtm_plataformaContenido || _params.vtm_plataformaContenido || window.voc_pl || _getPlataformaContenido() || WEB_CONTENT,
	    sistemaPublicacion: _query.vtm_sistemaPublicacion || _params.vtm_sistemaPublicacion || window.voc_pu || METHODE,
	    fechaPrimeraPublicacion: _query.vtm_fechaPrimeraPublicacion || _params.vtm_fechaPrimeraPublicacion || window.voc_fep || EMPTY,
	    fechaModificacion: _query.vtm_fechaModificacion || _params.vtm_fechaModificacion || window.voc_fem || EMPTY,
	    movilidad: _query.vtm_movilidad || _params.vtm_movilidad || window.voc_adp || (Cookies.get('voc_mobile') ? TWO : EMPTY),
	    hiperlocalSeccion: _query.vtm_hiperlocalSeccion || _params.vtm_hiperlocalSeccion || EMPTY,
	    hiperlocalEdicionEspecial: _query.vtm_hiperlocalEdicionEspecial || _params.vtm_hiperlocalEdicionEspecial || NO,
	    contenidoDestacado: _query.vtm_contenidoDestacado || _params.vtm_contenidoDestacado || NO,
	    origenPortada: _query.vtm_origenPortada || _params.vtm_origenPortada || window.voc_ho || (_isHomeReferrer() ? ONE : ZERO) || ZERO,
	    loMas: _query.vtm_loMas || _params.vtm_loMas || NO,
	    idioma: _query.vtm_idioma || _params.vtm_idioma || window.voc_idi || ES,
	    tipologiaLogin: _query.vtm_tipologiaLogin || _params.vtm_tipologiaLogin || window.voc_tusr || _userType || ANONYMOUS,
	    IDKrux: _query.vtm_IDKrux || _params.vtm_IDKrux || window.voc_krux || _krux || EMPTY,
	    IDGigya: _query.vtm_IDGigya || _params.vtm_IDGigya || window.voc_usrid || EMPTY,
	    edad: _query.vtm_edad || _params.vtm_edad || window.voc_usrag || EMPTY,
	    codigoPostal: _query.vtm_codigoPostal || _params.vtm_codigoPostal || window.voc_usrcp || EMPTY,
	    genero: _query.vtm_genero || _params.vtm_genero || window.voc_usrgen || EMPTY,
	    rutaNavegacion: _query.vtm_rutaNavegacion || _params.vtm_rutaNavegacion || EMPTY,
	    sitioRegistro: _query.vtm_sitioRegistro || _params.vtm_sitioRegistro || window.customService || EMPTY,
	    IDEvolok: _query.vtm_IDEvolok || _params.vtm_IDEvolok || window.voc_pw_pid || EMPTY,
	    productoEvolok: _query.vtm_productoEvolok || _params.vtm_productoEvolok || window.voc_pw_meter || EMPTY,
	    nPaginasConsumidas: _query.vtm_nPaginasConsumidas || _params.vtm_nPaginasConsumidas || window.voc_pw_count || EMPTY,
	    nPaginasPermitidas: _query.vtm_nPaginasPermitidas || _params.vtm_nPaginasPermitidas || window.voc_pw_max || EMPTY,
	    autorizacionContenido: _query.vtm_autorizacionContenido || _params.vtm_autorizacionContenido || window.voc_pw_result || EMPTY,
	    idCookieEvolok: _query.vtm_idCookieEvolok || _params.vtm_idCookieEvolok || window.voc_pw_cookie || Cookies.get('ev_sid') || EMPTY,
	    IDPedido: _query.vtm_IDPedido || _params.vtm_IDPedido || EMPTY,
	    SKU: _query.vtm_SKU || _params.vtm_SKU || EMPTY,
	    nombreProducto: _query.vtm_nombreProducto || _params.vtm_nombreProducto || EMPTY,
	    categoriaProducto: _query.vtm_categoriaProducto || _params.vtm_categoriaProducto || EMPTY,
	    unidadesProducto: _query.vtm_unidadesProducto || _params.vtm_unidadesProducto || EMPTY,
	    precio: _query.vtm_precio || _params.vtm_precio || EMPTY,
	    nombreTienda: _query.vtm_nombreTienda || _params.vtm_nombreTienda || EMPTY,
	    accionEcommerce: _query.vtm_accionEcommerce || _params.vtm_accionEcommerce || EMPTY,
	    impuestos: _query.vtm_impuestos || _params.vtm_impuestos || EMPTY,
	    gastosEnvio: _query.vtm_gastosEnvio || _params.vtm_gastosEnvio || EMPTY,
	    precioTotal: _query.vtm_precioTotal || _params.vtm_precioTotal || EMPTY,
	    fechaRegistroEcommerce: _query.vtm_fechaRegistroEcommerce || _params.vtm_fechaRegistroEcommerce || EMPTY,
	    CSsubchannel: _query.vtm_CSsubchannel || _params.vtm_CSsubchannel || EMPTY,
	    CSgrupo: _query.vtm_CSgrupo || _params.vtm_CSgrupo || EMPTY,
	    CSsubgrupo: _query.vtm_CSsubgrupo || _params.vtm_CSsubgrupo || EMPTY,
	    adBlockers: _query.vtm_adBlockers || _params.vtm_adBlockers || window.voc_adb || ZERO,
	    capasMostradas: _query.vtm_capasMostradas || _params.vtm_capasMostradas || EMPTY,
	    origenTags: _query.vtm_origenTags || _params.vtm_origenTags || NO,
	    firmaAutor: _query.vtm_firmaAutor || _params.vtm_firmaAutor || window.voc_au || EMPTY,
	    fichaAutor: _query.vtm_fichaAutor || _params.vtm_fichaAutor || (window.voc_or === AUT ? window.id_autor || window.voc_s1 : EMPTY),
	    origenContenido: _query.vtm_origenContenido || _params.vtm_origenContenido || window.voc_or || EMPTY,
	    topics: _query.vtm_topics || _params.vtm_topics || window.voc_top || EMPTY,
	    proceso: _query.vtm_proceso || _params.vtm_proceso || EMPTY,
	    funnel: _query.vtm_funnel || _params.vtm_funnel || EMPTY,
	    paso: _query.vtm_paso || _params.vtm_paso || EMPTY,
	    procesoFinalizado: _query.vtm_procesoFinalizado || _params.vtm_procesoFinalizado || EMPTY,
	    errorRechazo: _query.vtm_errorRechazo || _params.vtm_errorRechazo || EMPTY,
	    procesoEstatus: _query.vtm_procesoEstatus || _params.vtm_procesoEstatus || EMPTY,
	    tipoRegistroLogin: _query.vtm_tipoRegistroLogin || _params.vtm_tipoRegistroLogin || EMPTY,
	    tipoBuscador: _query.vtm_tipoBuscador || _params.vtm_tipoBuscador || EMPTY,
	    keyword: _query.vtm_keyword || _params.vtm_keyword || EMPTY,
	    nResultados: _query.vtm_nResultados || _params.vtm_nResultados || EMPTY,
	    errorBusqueda: _query.vtm_errorBusqueda || _params.vtm_errorBusqueda || EMPTY,
	    medioCampana: _query.vtm_medioCampana || _params.vtm_medioCampana || _params.ns_mchannel || _query.ns_mchannel || EMPTY,
	    origenCampana: _query.vtm_origenCampana || _params.vtm_origenCampana || _params.ns_source || _query.ns_source || EMPTY,
	    sitioCampana: _query.vtm_sitioCampana || _params.vtm_sitioCampana || EMPTY,
	    localizacion: _query.vtm_localizacion || _params.vtm_localizacion || EMPTY,
	    idCampana: _query.vtm_idCampana || _params.vtm_idCampana || _params.ns_campaign || _query.ns_campaign || EMPTY,
	    seccionContenidoCampana: _query.vtm_seccionContenidoCampana || _params.vtm_seccionContenidoCampana || _params.ns_linkname || _query.ns_linkname || EMPTY,
	    precioAsociadoCampana: _query.vtm_precioAsociadoCampana || _params.vtm_precioAsociadoCampana || _params.ns_fee || _query.ns_fee || EMPTY,
	    tipoCampana: _query.vtm_tipoCampana || _params.vtm_tipoCampana || EMPTY,
	    campanaPago: _query.vtm_campanaPagp || _params.vtm_campanaPagp || EMPTY,
	    contenidoEmbebido: _query.vtm_contenidoEmbebido || _params.vtm_contenidoEmbebido || NO,
	    swipeScreen: _query.vtm_swipeScreen || _params.vtm_swipeScreen || EMPTY,
	    slot: _query.vtm_slot || _params.vtm_slot || EMPTY
	  };
	}
	
	var properties = exports.properties = ['scrollInfinito', 'seccion', 'subseccion1', 'subseccion2', 'subseccion3', 'subseccion4', 'titular', 'errorPagina', 'tipoDominio', 'edicion', 'tipoContenido', 'tipoContenidoA', 'contenidoPremium', 'plataformaContenido', 'sistemaPublicacion', 'fechaPrimeraPublicacion', 'fechaModificacion', 'movilidad', 'hiperlocalSeccion', 'hiperlocalEdicionEspecial', 'contenidoDestacado', 'origenPortada', 'loMas', 'idioma', 'tipologiaLogin', 'IDKrux', 'IDGigya', 'edad', 'codigoPostal', 'genero', 'rutaNavegacion', 'sitioRegistro', 'IDEvolok', 'productoEvolok', 'nPaginasConsumidas', 'nPaginasPermitidas', 'autorizacionContenido', 'idCookieEvolok', 'IDPedido', 'SKU', 'nombreProducto', 'categoriaProducto', 'unidadesProducto', 'precio', 'nombreTienda', 'accionEcommerce', 'impuestos', 'gastosEnvio', 'precioTotal', 'fechaRegistroEcommerce', 'CSsubchannel', 'CSgrupo', 'CSsubgrupo', 'adBlockers', 'capasMostradas', 'origenTags', 'firmaAutor', 'fichaAutor', 'origenContenido', 'topics', 'proceso', 'funnel', 'paso', 'procesoFinalizado', 'errorRechazo', 'procesoEstatus', 'tipoRegistroLogin', 'tipoBuscador', 'keyword', 'nResultados', 'errorBusqueda', 'medioCampana', 'origenCampana', 'sitioCampana', 'localizacion', 'idCampana', 'seccionContenidoCampana', 'precioAsociadoCampana', 'tipoCampana', 'campanaPago', 'contenidoEmbebido', 'swipeScreen', 'slot'];
	
	var excludeSerialize = exports.excludeSerialize = ['IDEvolok', 'productoEvolok', 'nPaginasConsumidas', 'nPaginasPermitidas', 'autorizacionContenido', 'idCookieEvolok'];
	
	exports.default = properties;
	
	/* Private */
	
	function _getValueAtIndex(arr, index) {
	  console.log(arr, index);
	
	  if (index > arr.length - 1) {
	    return undefined;
	  }
	  if (arr.length && arr.length > index && (~arr[index].indexOf('.asp') || ~arr[index].indexOf('.php') || ~arr[index].indexOf('.html') || ~arr[index].indexOf('.htm'))) {
	    return undefined;
	  }
	
	  if (!index && !arr[index]) {
	    return 'portada';
	  }
	
	  return arr[index];
	}
	
	function _isHomeReferrer() {
	  var referrer = parseUrl(document.referrer);
	
	  return referrer.resource === document.location.hostname && (referrer.pathname === '/' || referrer.pathname === '/index.asp' || referrer.pathname === '/index.php' || referrer.pathname === '/index.htm' || referrer.pathname === '/index.html');
	}
	
	function _getPlataformaContenido() {
	  switch (true) {
	    case is.desktop():
	      return WEB_CONTENT;
	    case is.mobile() || is.tablet():
	      return M_RESPONSIVE;
	  }
	}
	
	function _hasSubdomain() {
	  return !/.*www$/.test(_site.subdomain);
	}

/***/ },

/***/ 59:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! Case - v1.5.2 - 2017-03-27
	* Copyright (c) 2017 Nathan Bubna; Licensed MIT, GPL */
	(function() {
	    "use strict";
	    var unicodes = function(s, prefix) {
	        prefix = prefix || '';
	        return s.replace(/(^|-)/g, '$1\\u'+prefix).replace(/,/g, '\\u'+prefix);
	    },
	    basicSymbols = unicodes('20-26,28-2F,3A-40,5B-60,7B-7E,A0-BF,D7,F7', '00'),
	    baseLowerCase = 'a-z'+unicodes('DF-F6,F8-FF', '00'),
	    baseUpperCase = 'A-Z'+unicodes('C0-D6,D8-DE', '00'),
	    improperInTitle = 'A|An|And|As|At|But|By|En|For|If|In|Of|On|Or|The|To|Vs?\\.?|Via',
	    regexps = function(symbols, lowers, uppers, impropers) {
	        symbols = symbols || basicSymbols;
	        lowers = lowers || baseLowerCase;
	        uppers = uppers || baseUpperCase;
	        impropers = impropers || improperInTitle;
	        return {
	            capitalize: new RegExp('(^|['+symbols+'])(['+lowers+'])', 'g'),
	            pascal: new RegExp('(^|['+symbols+'])+(['+lowers+uppers+'])', 'g'),
	            fill: new RegExp('['+symbols+']+(.|$)','g'),
	            sentence: new RegExp('(^\\s*|[\\?\\!\\.]+"?\\s+"?|,\\s+")(['+lowers+'])', 'g'),
	            improper: new RegExp('\\b('+impropers+')\\b', 'g'),
	            relax: new RegExp('([^'+uppers+'])(['+uppers+']*)(['+uppers+'])(?=['+lowers+']|$)', 'g'),
	            upper: new RegExp('^[^'+lowers+']+$'),
	            hole: /[^\s]\s[^\s]/,
	            apostrophe: /'/g,
	            room: new RegExp('['+symbols+']')
	        };
	    },
	    re = regexps(),
	    _ = {
	        re: re,
	        unicodes: unicodes,
	        regexps: regexps,
	        types: [],
	        up: String.prototype.toUpperCase,
	        low: String.prototype.toLowerCase,
	        cap: function(s) {
	            return _.up.call(s.charAt(0))+s.slice(1);
	        },
	        decap: function(s) {
	            return _.low.call(s.charAt(0))+s.slice(1);
	        },
	        deapostrophe: function(s) {
	            return s.replace(re.apostrophe, '');
	        },
	        fill: function(s, fill, deapostrophe) {
	            if (fill != null) {
	                s = s.replace(re.fill, function(m, next) {
	                    return next ? fill + next : '';
	                });
	            }
	            if (deapostrophe) {
	                s = _.deapostrophe(s);
	            }
	            return s;
	        },
	        prep: function(s, fill, pascal, upper) {
	            s = s == null ? '' : s + '';// force to string
	            if (!upper && re.upper.test(s)) {
	                s = _.low.call(s);
	            }
	            if (!fill && !re.hole.test(s)) {
	                var holey = _.fill(s, ' ');
	                if (re.hole.test(holey)) {
	                    s = holey;
	                }
	            }
	            if (!pascal && !re.room.test(s)) {
	                s = s.replace(re.relax, _.relax);
	            }
	            return s;
	        },
	        relax: function(m, before, acronym, caps) {
	            return before + ' ' + (acronym ? acronym+' ' : '') + caps;
	        }
	    },
	    Case = {
	        _: _,
	        of: function(s) {
	            for (var i=0,m=_.types.length; i<m; i++) {
	                if (Case[_.types[i]](s) === s){ return _.types[i]; }
	            }
	        },
	        flip: function(s) {
	            return s.replace(/\w/g, function(l) {
	                return (l == _.up.call(l) ? _.low : _.up).call(l);
	            });
	        },
	        random: function(s) {
	            return s.replace(/\w/g, function(l) {
	                return (Math.round(Math.random()) ? _.up : _.low).call(l);
	            });
	        },
	        type: function(type, fn) {
	            Case[type] = fn;
	            _.types.push(type);
	        }
	    },
	    types = {
	        lower: function(s, fill, deapostrophe) {
	            return _.fill(_.low.call(_.prep(s, fill)), fill, deapostrophe);
	        },
	        snake: function(s) {
	            return Case.lower(s, '_', true);
	        },
	        constant: function(s) {
	            return Case.upper(s, '_', true);
	        },
	        camel: function(s) {
	            return _.decap(Case.pascal(s));
	        },
	        kebab: function(s) {
	            return Case.lower(s, '-', true);
	        },
	        header: function(s) {
	            return Case.capital(s, '-', true);
	        },
	        upper: function(s, fill, deapostrophe) {
	            return _.fill(_.up.call(_.prep(s, fill, false, true)), fill, deapostrophe);
	        },
	        capital: function(s, fill, deapostrophe) {
	            return _.fill(_.prep(s).replace(re.capitalize, function(m, border, letter) {
	                return border+_.up.call(letter);
	            }), fill, deapostrophe);
	        },
	        pascal: function(s) {
	            return _.fill(_.prep(s, false, true).replace(re.pascal, function(m, border, letter) {
	                return _.up.call(letter);
	            }), '', true);
	        },
	        title: function(s) {
	            return Case.capital(s).replace(re.improper, function(small, p, i, s) {
	                return i > 0 && i < s.lastIndexOf(' ') ? _.low.call(small) : small;
	            });
	        },
	        sentence: function(s, names) {
	            s = Case.lower(s).replace(re.sentence, function(m, prelude, letter) {
	                return prelude + _.up.call(letter);
	            });
	            if (names) {
	                names.forEach(function(name) {
	                    s = s.replace(new RegExp('\\b'+Case.lower(name)+'\\b', "g"), _.cap);
	                });
	            }
	            return s;
	        }
	    };
	    
	    // TODO: Remove "squish" in a future breaking release.
	    types.squish = types.pascal;
	
	    for (var type in types) {
	        Case.type(type, types[type]);
	    }
	    // export Case (AMD, commonjs, or global)
	    var define = __webpack_require__(60);
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (typeof module === "object" && module.exports ? module.exports = Case : this.Case = Case), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	}).call(this);


/***/ },

/***/ 60:
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },

/***/ 61:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propertyId = exports.bodyScript = exports.headScript = undefined;
	
	var _constants = __webpack_require__(55);
	
	var headScript = document.createElement('script'),
	    bodyScript = document.createElement('script'),
	    currentScript = document.currentScript || function () {
	  var scripts = document.getElementsByTagName('script');
	  return scripts[scripts.length - 1];
	}();
	
	var propertyId = currentScript.getAttribute('data-property-id') || '';
	
	headScript.id = _constants.HEAD_DEPLOY_SELECTOR_ID;
	headScript.src = _constants.TAG_MANAGER_URL.replace(/{{property-id}}/, propertyId);
	
	bodyScript.id = _constants.BODY_DEPLOY_SELECTOR_ID;
	bodyScript.innerHTML = _constants.GLOBAL_LIB_VAR + '.pageBottom();';
	
	exports.headScript = headScript;
	exports.bodyScript = bodyScript;
	exports.propertyId = propertyId;

/***/ },

/***/ 62:
/***/ function(module, exports) {

	/**
	 * Code refactored from Mozilla Developer Network:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 */
	
	'use strict';
	
	function assign(target, firstSource) {
	  if (target === undefined || target === null) {
	    throw new TypeError('Cannot convert first argument to object');
	  }
	
	  var to = Object(target);
	  for (var i = 1; i < arguments.length; i++) {
	    var nextSource = arguments[i];
	    if (nextSource === undefined || nextSource === null) {
	      continue;
	    }
	
	    var keysArray = Object.keys(Object(nextSource));
	    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	      var nextKey = keysArray[nextIndex];
	      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	      if (desc !== undefined && desc.enumerable) {
	        to[nextKey] = nextSource[nextKey];
	      }
	    }
	  }
	  return to;
	}
	
	function polyfill() {
	  if (!Object.assign) {
	    Object.defineProperty(Object, 'assign', {
	      enumerable: false,
	      configurable: true,
	      writable: true,
	      value: assign
	    });
	  }
	}
	
	module.exports = {
	  assign: assign,
	  polyfill: polyfill
	};


/***/ },

/***/ 65:
/***/ function(module, exports) {

	module.exports = {
		"name": "vtm",
		"version": "2.2.36",
		"description": "Vocento Tag Manager",
		"main": "src/index.js",
		"scripts": {
			"start": "webpack-dev-server --content-base dist/",
			"build": "./node_modules/.bin/webpack"
		},
		"author": "Iván Pérez <ivanperez@vocento.com>",
		"license": "SEE LICENSE IN LICENSE.md",
		"devDependencies": {
			"babel-core": "^6.17.0",
			"babel-loader": "^6.2.5",
			"babel-preset-es2015": "^6.16.0",
			"chai": "^3.5.0",
			"chalk": "^1.1.3",
			"html-webpack-plugin": "^2.28.0",
			"json-loader": "^0.5.4",
			"mocha": "^3.1.0",
			"mocha-loader": "^1.0.0",
			"webpack": "^1.13.2",
			"webpack-shell-plugin": "^0.4.3"
		},
		"dependencies": {
			"case": "^1.4.2",
			"es6-object-assign": "^1.1.0"
		}
	};

/***/ }

/******/ })
});
;


// WEBPACK FOOTER //
// vtm.js